// extracted by mini-css-extract-plugin
export default {"container":"T1-z","heading":"U1-z","links":"V1-z","copy":"W1-z","subCopy":"X1-z","linksLeft":"Y1-z","linksCenter":"Z1-z","linksRight":"_1-z","link":"a2-z","onlyLink":"b2-z"};